export interface WhatsAppConfig {
  id?: string;
  centerGroupId?: number;
  isActive: boolean;
  accountSid: string;
  authToken: string;
  fromPhoneNumber: string;
  statusCallbackBaseUrl?: string | null;
  maxWhatsAppPerHourPerUser: number;
  createdAt?: string;
  updatedAt?: string | null;
}

export interface WhatsAppCreateRequest {
  accountSid: string;
  authToken: string;
  fromPhoneNumber: string;
  statusCallbackBaseUrl?: string | null;
  maxWhatsAppPerHourPerUser?: number;
}

export interface WhatsAppUpdateRequest {
  accountSid?: string;
  authToken?: string | null;
  fromPhoneNumber?: string;
  statusCallbackBaseUrl?: string | null;
  maxWhatsAppPerHourPerUser?: number;
  isActive?: boolean;
}

export interface WhatsAppTestResponse {
  success: boolean;
  message: string;
  testedAt?: string;
}
